import React from 'react'
import {nanoid} from "nanoid"


export default function QnA(props){
    const check = props.check
    const [answers,setAnswers] = React.useState(props.allAnswers)
    const [classNameAns,setClassNameAns] =React.useState("ans")
  
   console.log(answers)
    const answerButtons = answers.map(answer=>(
        <button 
            key={answer.id} 
            className={getButtonColor(answer.clicked,answer.correct)}
            onClick={()=>handleClick(answer.correct,answer.id)}
        >
          {answer.text}
        </button>    

    ))
     
    function getButtonColor(clicked,correct){
        if(check){
            if(correct){
                return "ans btn-green"
            }else if(clicked && !correct){
                return "ans btn-red"
            }else{
                return "ans ans-active"
            }
        }else{  
            if(clicked){
                return "ans ans-active"
            }else{
                return "ans"
            }            
        }
    }
    
    function handleClick(correct,id){
     props.countPoints(correct,props.id)

     setAnswers(prev=>prev.map(answer=>{
         if(answer.id===id){
             return {...answer, clicked:true}
         }else{
             return {...answer, clicked:false}
         }
     }))
 
}
  
     return(
         <div className="quiz-question">
             <h3>{props.question}</h3>
             <div className='ans-div'>
               {answerButtons}
             </div>
             <hr></hr>
         </div>    
     )
}
// import React from "react"
// import {nanoid} from "nanoid"
// import MarkdownView from "react";

// export default function QnA(props){
//     const checking = props.checking
//     const [answers, setAnswers] = React.useState(props.allAnswers)

    
//     const answerButtons = answers.map(answer=>(
//         <button key={answer.id} className={getButtonColor(answer.clicked,answer.correct)} onClick={()=>handleClick(answer.correct,answer.id)}><MarkdownView className="markdown" markdown={answer.text}/></button>   
//     ))
    
//     function getButtonColor(clicked,correct){

//         if(checking){
//             if(correct){
//                return "green-btn"
//             }else if(clicked && !correct){
//                 return "red-btn"
//             }else{
//                 return "answer-btn"
//             }
//         }else{
//             if(clicked){
//                return "answer-btn-clicked"
//             }else{
//                 return "answer-btn"
//             }
//         }
//     }
      
//     function handleClick(correct,id) {
      
//         props.countScore(correct,props.id)
       
//         setAnswers(oldArray => oldArray.map(answer =>{
                           
//             if(answer.id===id){
//                 return {...answer, clicked:true}
//             }else{
//                 return {...answer,clicked:false}
//             }
//         }))
//     }
    
   
//     return(
//         <div>
//         <MarkdownView markdown={props.question}/>
//             <p>{answerButtons}</p>
//         </div>
         
      
//     )
    
// }
